import appReducers from '../reducer/app';
import iamReducers from "../reducer/iam";
import contentReducers from "../reducer/content";
import inboxReducers from "../reducer/inbox/inbox";
import settingReducers from "../reducer/setting/index";
import assessmentDataReducers from "../reducer/assessmentData";
import regularPlanReducers from "../reducer/regularPlan";
import assessmentReviewMeetingReducers from "../reducer/assessmentReviewMeeting";
import irregularApplicationReducers from "../reducer/irregularApplication";
import marketTestInboxReducers from "../reducer/marketTestInbox";
import marketTestReducers from "../reducer/marketTest";
import applicationManagementReducers from "../reducer/applicationManagement";
import applicationProcessingReducers from "../reducer/applicationProcessing";
import overdueApplicationInboxReducers from "../reducer/overdueApplicationInbox";
import customerManagementReducers from "../reducer/customerManagement";
import kpiReducers from "../reducer/kpi";
import testListReducers from "../reducer/testList";
import workflowRoleSettingReducers from "../reducer/workflowRoleSetting";
import leezenApplicationManagementReducers from "../reducer/leezenApplicationManagement";
import accountStatementReducers from "../reducer/accountStatement";
import letterTemplateReducers from "../reducer/letterTemplate";
import accountReducers from "../reducer/account";
import utilReducers from "../reducer/util";
import deputyReducers from "../reducer/deputy";
import deputyByRolesReducers from "../reducer/deputyByRoles";
import foodAdditiveReducers from "../reducer/foodAdditive";
import organizationReducers from "../reducer/organization";
import systemCodeReducers from "../reducer/systemCode";
import customerManagementSurveyReducers from "../reducer/customerManagementSurvey"
import inboxCountReducers from "../reducer/inboxCount"
import changeInspectorReducers from "../reducer/changeInspector";
import leezenCustomerManagementReducers from "../reducer/leezenCustomerManagement"

const rootReducer = {
    ...appReducers,
    ...iamReducers,
    ...contentReducers,
    ...inboxReducers,
    ...inboxCountReducers,
    ...settingReducers,
    ...assessmentDataReducers,
    ...regularPlanReducers,
    ...assessmentReviewMeetingReducers,
    ...irregularApplicationReducers,
    ...marketTestInboxReducers,
    ...marketTestReducers,
    ...applicationManagementReducers,
    ...applicationProcessingReducers,
    ...changeInspectorReducers,
    ...overdueApplicationInboxReducers,
    ...customerManagementReducers,
    ...leezenCustomerManagementReducers,
    ...customerManagementSurveyReducers,
    ...kpiReducers,
    ...testListReducers,
    ...workflowRoleSettingReducers,
    ...leezenApplicationManagementReducers,
    ...accountStatementReducers,
    ...letterTemplateReducers,
    ...accountReducers,
    ...utilReducers,
    ...deputyReducers,
    ...deputyByRolesReducers,
    ...foodAdditiveReducers,
    ...organizationReducers,
    ...systemCodeReducers
};

export default rootReducer;
